import React, { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

import * as api from "@nens/threedi/openapi-client";

import { getV3BetaApi } from "../../apiConfiguration";
import { getExistingLeveeEdits } from "../../state/existingEvents";
import { menuExistingItemCardRow } from "../../styles/styleComposition";
import { simulationIdFromUrl } from "../../utils/apiUtils";

import ExistingItemCard from "./ExistingItemCard";

const ExistingLeveeEdit: React.FC<{
  leveeEdit: api.ObstacleEdit;
}> = ({ leveeEdit }) => {
  const onDelete = useCallback(async () => {
    const v3Api = getV3BetaApi();
    if (leveeEdit && leveeEdit.id && leveeEdit.simulation) {
      try {
        await v3Api.simulationsEventsObstacleEditsDelete({
          id: leveeEdit.id,
          simulationPk: simulationIdFromUrl(leveeEdit.simulation),
        });
      } catch (e) {
        // XXX.
      }
    }
  }, [leveeEdit]);

  return (
    <ExistingItemCard onDelete={onDelete} start={leveeEdit.offset} controlType="deleteEdit">
      <div className={menuExistingItemCardRow}>
        <span>
          <FormattedMessage id="existingRasterEdits.value" defaultMessage="Value" />:
        </span>
        <span>
          {/* {leveeEdit.relative ? (leveeEdit.value >= 0 ? "+ " : "") : "= "} */}
          {leveeEdit.value}
        </span>
      </div>
    </ExistingItemCard>
  );
};

const ExistingLeveeEdits = () => {
  const existingLeveeEvents = useSelector(getExistingLeveeEdits);

  return (
    <div>
      {existingLeveeEvents.map((existingItem) => {
        return <ExistingLeveeEdit key={existingItem.url} leveeEdit={existingItem} />;
      })}
    </div>
  );
};

export default ExistingLeveeEdits;
